import { constants, typographyStyles } from "@newsela/angelou";

import {
  bodyLineHeight,
  powerWordPopOutBodyFontSizes,
  powerWordPopOutIconSizes,
  powerWordPopOutTitleFontSizes,
} from "@/view/constants/styles/accessibleFontSizeMapping/accessibleFontSizeMapping.style";

const { colors } = constants;
const grey = colors.ui.neutral[500];
const neutral700 = colors.ui.neutral[700];
const greyLight = colors.ui.neutral[100];

const { textXSObj } = typographyStyles;

const getIconSize = (currentFontSize) =>
  powerWordPopOutIconSizes[currentFontSize];

export const bodyWrapperCss = (hasFooter) => ({
  padding: "0 17px 0 12px",
  marginBottom: hasFooter ? "0px" : "16px",
});

export const keyTermWrapperCss = {
  alignItems: "center",
  display: "flex",
  marginBottom: "16px",
};

export const keyTermCss = (accessibleFontSize) => ({
  color: neutral700,
  display: "inline-block",
  margin: "0",
  fontSize: powerWordPopOutTitleFontSizes[accessibleFontSize],
});

export const readAloudIconCss = (accessibleFontSize) => ({
  color: neutral700,
  height: getIconSize(accessibleFontSize),
  width: getIconSize(accessibleFontSize),
});

export const readAloudButtonOverrideCss = {
  padding: "3px",
  marginLeft: "8px",
  position: "relative",
};

export const definitionBodyCss = (accessibleFontSize) => ({
  color: grey,
  fontSize: powerWordPopOutBodyFontSizes[accessibleFontSize],
  lineHeight: bodyLineHeight,
});

export const footerCss = {
  padding: "12px 12px 14px 12px",
  borderTop: `1px solid ${greyLight}`,
};

export const buttonContainerCss = {
  display: "flex",
  marginTop: "16px",
  gap: "2px",
};

export const aiIconCss = {
  root: {
    display: "inline-flex",
    marginRight: "2px",
    verticalAlign: "bottom",
  },
};

export const aiMessageCss = {
  ...textXSObj,
  display: "inline",
  color: grey,
};

export const featureButtonCss = {
  padding: "8px",
};
